import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOpportunityMSTeamMemberListData } from './mockData'
import type { THrid } from '~/types/models'
import type { IOpportunityMSTeamMember } from '@/types/opportunity/models'

interface GetOpportunityMSTeamMembersResponse {
  data: IOpportunityMSTeamMember[] | undefined
}

// post

const postOpportunityMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOpportunityMSTeamMemberListData)
}

const patchOpportunityMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOpportunityMSTeamMemberListData)
}

const deleteOpportunityMSTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOpportunityMSTeamMemberListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/opportunitymsteammembers',
    handler: postOpportunityMSTeamMember,
  },
  {
    method: 'patch',
    path: '/api/opportunitymsteammembers/:id',
    handler: patchOpportunityMSTeamMember,
  },
  {
    method: 'delete',
    path: '/api/opportunitymsteammembers/:id',
    handler: deleteOpportunityMSTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
